import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Profile from "@material-ui/icons/AccountCircle";
import Chat from "@material-ui/icons/Chat";
import Contacts from "@material-ui/icons/Contacts";
import Assignment from "@material-ui/icons/Assignment";
import Tasks from "@material-ui/icons/PlaylistAddCheck";
import Notes from "@material-ui/icons/Subject";
import OportunityIcon from '@material-ui/icons/WbIncandescent';
import DealIcon from "@material-ui/icons/BusinessCenter";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import ContactData from './ContactData.jsx'
import ContactsTab from './ContactsTab.jsx'
import NotesTab from './NotesTab.jsx'
import TasksTab from './TasksTab.jsx'
import OportunitiesTab from './OportunitiesTab.jsx'
import DealsTab from './DealsTab.jsx'

const styles = {
  textCenter: {
    textAlign: "center"
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
};

class ContactTabs extends React.Component{
  render(){
    const { classes } = this.props;
    const { profile } = this.props;
    return (
      <div>
        <CustomTabs
          plainTabs
          headerColor="info"
          tabs={[
            {
              tabName: "Profile",
              tabIcon: Profile,
              tabContent: (
                    <ContactData profile={profile} />
              )
            },
            {
              tabName: "Contacts",
              tabIcon: Contacts,
              tabContent: (
                  <ContactsTab profile={profile} />

              )
            },
            {
              tabName: "Tasks",
              tabIcon: Tasks,
              tabContent: (
                    <TasksTab profile={profile} />
              )
            },
            {
              tabName: "Notes",
              tabIcon: Notes,
              tabContent: (
                    <NotesTab profile={profile} />
              )
            },
            {
              tabName: "Oportunities",
              tabIcon: OportunityIcon,
              tabContent: (
                    <OportunitiesTab profile={profile} />
              )
            },
            {
              tabName: "Deals",
              tabIcon: DealIcon,
              tabContent: (
                    <DealsTab profile={profile} />
              )
            }
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ContactTabs);
